define(["exports", "./utils", "../core/l10n", "hyperhtml"], function (_exports, _utils, _l10n, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<li class='tofline'>\n    <a class='tocxref' href='", "'>", "</a>\n  </li>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<bdi class='figno'>", "</bdi>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["<span class='fig-title'>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["<ul class='tof'>", "</ul>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<h2>", "</h2>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/figures";
  _exports.name = name;
  const localizationStrings = {
    en: {
      list_of_figures: "List of Figures",
      fig: "Figure "
    },
    ja: {
      fig: "図",
      list_of_figures: "図のリスト"
    },
    ko: {
      fig: "그림 ",
      list_of_figures: "그림 목록"
    },
    nl: {
      fig: "Figuur ",
      list_of_figures: "Lijst met figuren"
    },
    es: {
      fig: "Figura ",
      list_of_figures: "Lista de Figuras"
    },
    zh: {
      fig: "圖 ",
      list_of_figures: "List of Figures"
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];

  function run() {
    normalizeImages(document);
    const tof = collectFigures(); // Create a Table of Figures if a section with id 'tof' exists.

    const tofElement = document.getElementById("tof");

    if (tof.length && tofElement) {
      decorateTableOfFigures(tofElement);
      tofElement.append((0, _hyperhtml.default)(_templateObject(), l10n.list_of_figures), (0, _hyperhtml.default)(_templateObject2(), tof));
    }
  }
  /**
   * process all figures
   */


  function collectFigures() {
    /** @type {HTMLElement[]} */
    const tof = [];
    document.querySelectorAll("figure").forEach((fig, i) => {
      const caption = fig.querySelector("figcaption");

      if (caption) {
        decorateFigure(fig, caption, i);
        tof.push(getTableOfFiguresListItem(fig.id, caption));
      } else {
        (0, _utils.showInlineWarning)(fig, "Found a `<figure>` without a `<figcaption>`");
      }
    });
    return tof;
  }
  /**
   * @param {HTMLElement} figure
   * @param {HTMLElement} caption
   * @param {number} i
   */


  function decorateFigure(figure, caption, i) {
    const title = caption.textContent;
    (0, _utils.addId)(figure, "fig", title); // set proper caption title

    (0, _utils.wrapInner)(caption, (0, _hyperhtml.default)(_templateObject3()));
    caption.prepend(l10n.fig, (0, _hyperhtml.default)(_templateObject4(), i + 1), " ");
  }
  /**
   * @param {string} figureId
   * @param {HTMLElement} caption
   * @return {HTMLElement}
   */


  function getTableOfFiguresListItem(figureId, caption) {
    const tofCaption = caption.cloneNode(true);
    tofCaption.querySelectorAll("a").forEach(anchor => {
      (0, _utils.renameElement)(anchor, "span").removeAttribute("href");
    });
    return (0, _hyperhtml.default)(_templateObject5(), "#".concat(figureId), tofCaption.childNodes);
  }

  function normalizeImages(doc) {
    doc.querySelectorAll(":not(picture)>img:not([width]):not([height]):not([srcset])").forEach(img => {
      if (img.naturalHeight === 0 || img.naturalWidth === 0) return;
      img.height = img.naturalHeight;
      img.width = img.naturalWidth;
    });
  }
  /**
   * if it has a parent section, don't touch it
   * if it has a class of appendix or introductory, don't touch it
   * if all the preceding section siblings are introductory, make it introductory
   * if there is a preceding section sibling which is an appendix, make it appendix
   * @param {Element} tofElement
   */


  function decorateTableOfFigures(tofElement) {
    if (tofElement.classList.contains("appendix") || tofElement.classList.contains("introductory") || tofElement.closest("section")) {
      return;
    }

    const previousSections = getPreviousSections(tofElement);

    if (previousSections.every(sec => sec.classList.contains("introductory"))) {
      tofElement.classList.add("introductory");
    } else if (previousSections.some(sec => sec.classList.contains("appendix"))) {
      tofElement.classList.add("appendix");
    }
  }
  /**
   * @param {Element} element
   */


  function getPreviousSections(element) {
    /** @type {Element[]} */
    const sections = [];

    for (const previous of iteratePreviousElements(element)) {
      if (previous.localName === "section") {
        sections.push(previous);
      }
    }

    return sections;
  }
  /**
   * @param {Element} element
   */


  function* iteratePreviousElements(element) {
    let previous = element;

    while (previous.previousElementSibling) {
      previous = previous.previousElementSibling;
      yield previous;
    }
  }
});
//# sourceMappingURL=figures.js.map